import ChasefeedService from './chasefeed-service';
import ChaseNowService from './chasenow-service';
import CustomerService from './customer-service';
import InvoiceService from './invoice-service';
import ManageService from './manage-service';
import ScheduleService from './schedule-service';
import NotificationService from './notification-service';
import AccountService from './account-service';
import OrganisationService from './organisation-service';
import SettingsService from './settings-service';
import TemplateService from './template-service';
import TimingService from './timing-service';
import ReportsService from './reports-service';
import TaskService from './task-service';
import DrmMetricsService from './drm-metrics-service';

// Collections of endpoints grouped by domain, in order for data to be invalidated in bulk.
// E.g. when a user clicks the Sync button, we can mark all organisation data as stale by calling `invalidateDomain('organisation')`
// and all the data belonging to all the endpoints in that domain will be fetched again when needed.

const domains = {
  organisation: all(
    ChasefeedService,
    ChaseNowService,
    CustomerService,
    InvoiceService,
    ManageService,
    ScheduleService,
    OrganisationService,
    SettingsService,
    TemplateService,
    TimingService,
    ReportsService,
    TaskService,
  ),
  drmMetrics: [DrmMetricsService.getMetric, DrmMetricsService.getFreshness],
  user: all(AccountService, NotificationService),
  invoice: all(InvoiceService),
  customer: all(CustomerService),
  schedule: all(ScheduleService),
  template: all(TemplateService),
};

function all(...services) {
  return services.flatMap(s => Object.values(s));
}

export default domains;
